"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleId = void 0;
var ModuleId;
(function (ModuleId) {
    ModuleId["BlogImporter"] = "BLOG_IMPORTER_BUSINESS_MANAGER";
    ModuleId["Home"] = "HOME";
    ModuleId["Settings"] = "SETTINGS";
    ModuleId["SiteSettings"] = "SITE_SETTINGS";
    ModuleId["Gdpr"] = "GDPR_USERS_CLIENT";
    ModuleId["InboxKeyboards"] = "INBOX_KEYBOARDS";
    ModuleId["Engage"] = "ENGAGE";
    ModuleId["InboxSettings"] = "INBOX_SETTINGS";
    ModuleId["EngageAngular"] = "ENGAGE_ANGULAR";
    ModuleId["Invoices"] = "INVOICES";
    ModuleId["PriceQuotes"] = "PRICE_QUOTES";
    ModuleId["Challenges"] = "CHALLENGES_WEB_BUSINESS_MANAGER";
    ModuleId["Stores"] = "STORES";
    ModuleId["Shoutout"] = "SHOUTOUT";
    ModuleId["Cashier"] = "CASHIER";
    ModuleId["CashierPaymentsDashboard"] = "CASHIER_PAYMENTS_DASHBOARD";
    ModuleId["AppMarket"] = "APP_MARKET";
    ModuleId["Bookings"] = "BOOKINGS";
    ModuleId["Contacts"] = "CONTACTS";
    ModuleId["MemberPermissions"] = "MEMBER_PERMISSIONS";
    ModuleId["EditorPermissions"] = "EDITOR_PERMISSIONS";
    ModuleId["WixForms"] = "WIX_FORMS";
    ModuleId["Examples"] = "EXAMPLES";
    ModuleId["PromoteSeo"] = "PROMOTE_SEO";
    ModuleId["Restaurants"] = "RESTAURANTS";
    ModuleId["RestaurantsOrders"] = "RESTAURANTS_ORDERS";
    ModuleId["RestaurantsReservations"] = "RESTAURANTS_RESERVATIONS";
    ModuleId["RestaurantsSocialBar"] = "RESTAURANTS_SOCIAL_BAR";
    ModuleId["EtpaContainer"] = "ETPA_CONTAINER";
    ModuleId["Coupons"] = "COUPONS";
    ModuleId["Triggers"] = "TRIGGERS";
    ModuleId["CodeEmbed"] = "CODE_EMBED";
    ModuleId["Events"] = "EVENTS";
    ModuleId["MusicManager"] = "MUSIC_MANAGER";
    ModuleId["Video"] = "VIDEO";
    ModuleId["VideoMaker"] = "VIDEO_MAKER";
    ModuleId["PhotoAlbums"] = "PHOTOGRAPHY-ALBUMS";
    ModuleId["ArtStore"] = "PHOTOGRAPHY-GALLERY";
    ModuleId["SocialBlog"] = "SOCIAL_BLOG";
    ModuleId["OldBlog"] = "OLD_BLOG";
    ModuleId["Multilingual"] = "MULTILINGUAL";
    ModuleId["MarketingIntegration"] = "MARKETING_INTEGRATION";
    ModuleId["WixCodeDatabase"] = "WIX_DATABASES";
    ModuleId["AdminPage"] = "ADMIN_PAGES";
    ModuleId["TasksWeb"] = "TASKS_WEB";
    ModuleId["Membership"] = "MEMBERSHIP";
    ModuleId["BadgeDefinitions"] = "BADGE_DEFINITIONS";
    ModuleId["ShareitWeb"] = "SHARE_IT_WEB";
    ModuleId["Workflow"] = "WORKFLOW";
    ModuleId["PromoteHome"] = "PROMOTE_HOME";
    ModuleId["PingNotifications"] = "PING_NOTIFICATION_SETTINGS";
    ModuleId["Ascend"] = "ASCEND";
    ModuleId["SiteSubscriptions"] = "PREMIUM_SITE_SUBSCRIPTIONS";
    ModuleId["VideoMakerHome"] = "VIDEO_MAKER_HOME";
    ModuleId["ReleaseManager"] = "RELEASE_MANAGER_CLIENT";
    ModuleId["WixCodeSiteMonitoring"] = "WIX_CODE_SITE_MONITORING";
    ModuleId["WixCodeSecretsManager"] = "WIX_CODE_SECRETS_MANAGER";
    ModuleId["WixCodeSiteBranches"] = "WIX_CODE_SITE_BRANCHES";
    ModuleId["WixPayments"] = "WIX_PAYMENTS_DASHBOARD";
    ModuleId["WixPaymentsTransactions"] = "WIX_PAYMENTS_TRANSACTIONS";
    ModuleId["WixPaymentsBalance"] = "WIX_PAYMENTS_BALANCE";
    ModuleId["Automations"] = "AUTOMATIONS";
    ModuleId["PromotePaidAds"] = "PROMOTE_PAID_ADS";
    ModuleId["WixPhotoAlbums"] = "ALBUMS_BUSINESS_MANAGER";
    ModuleId["WixExpertsDashboard"] = "EXPERTS_DASHBOARD";
    ModuleId["WixExpertsLoyalty"] = "EXPERTS_LOYALTY_BUSINESS_MANAGER";
    ModuleId["WixPartnerDeals"] = "PARTNER_DEALS";
    ModuleId["WixExpertsStudio"] = "EXPERTS_STUDIO";
    ModuleId["WixExpertsSettings"] = "experts-settings";
    ModuleId["WixExpertsAscendZeroState"] = "EXPERTS_ASCEND_ZERO_STATE";
    ModuleId["WixExpertsClientBilling"] = "experts-client-billing";
    ModuleId["Analytics"] = "ANALYTICS";
    ModuleId["ArenaBizManager"] = "ARENA";
    ModuleId["ArenaWorkflowBizManager"] = "ARENA_WORKFLOW";
    ModuleId["PromoteSeoPatterns"] = "PROMOTE_SEO_PATTERNS";
    ModuleId["PromoteSeoTools"] = "PROMOTE_SEO_TOOLS";
    ModuleId["LogoBuilder"] = "LOGO_BUILDER";
    ModuleId["PrintShop"] = "PRINT_SHOP";
    ModuleId["RicosPlayground"] = "RICOS_PLAYGROUND";
    ModuleId["FinancialApps"] = "FINANCIAL_APP_COLLECTION";
    ModuleId["MobileTab"] = "MOBILE_TAB_BM";
    ModuleId["SocialGroupsDashboard"] = "SOCIAL_GROUPS_DASHBOARD";
    ModuleId["MarketplaceContainer"] = "MARKETPLACE_CONTAINER";
    ModuleId["RestaurantsCallCenter"] = "RESTAURANTS_CALL_CENTER";
    ModuleId["VirtualNumbers"] = "VIRTUAL_NUMBERS";
    ModuleId["AssigneeWEB"] = "ASSIGNEE_WEB";
    ModuleId["Forum"] = "FORUM";
    ModuleId["RolesAndPermissions"] = "SITE_ROLES_AND_PERMISSIONS";
    ModuleId["WixPartnersTeam"] = "PARTNERS_TEAM";
    ModuleId["CoBranding"] = "CO_BRANDING";
    ModuleId["Subscriptions"] = "SUBSCRIPTIONS_BM";
    ModuleId["Loyalty"] = "LOYALTY_BM";
    ModuleId["AnalyticsNG"] = "ANALYTICS_NG_BM";
    ModuleId["NewReleasesWidget"] = "NEW_RELEASES_WIDGET";
    ModuleId["ZoomApp"] = "ZOOM_APP";
    ModuleId["SiteHistory"] = "SITE_HISTORY_CLIENT";
    ModuleId["CrmHome"] = "crm-home";
    ModuleId["Paywall"] = "PAYWALL";
    ModuleId["BusinessManagerSettings"] = "BUSINESS_MANAGER_SETTINGS";
    ModuleId["Fedata"] = "FEDATA";
    ModuleId["WebsiteSettings"] = "WEBSITE_SETTINGS";
    ModuleId["LanguageAndRegionSettings"] = "LANGUAGE_AND_REGION_SETTINGS";
    ModuleId["StoresShipping"] = "STORES_SHIPPING";
    ModuleId["BusinessInfo"] = "BUSINESS_INFO";
    ModuleId["LiveVideo"] = "LIVE_VIDEO";
    ModuleId["PartnersPackage"] = "PREMIUM_PARTNERS_PACKAGE_CLIENT";
    ModuleId["AppMarketEtpaContainer"] = "APP_MARKET_ETPA_CONTAINER";
    ModuleId["WixlabsModals"] = "BM-MODALS-WIXLABS";
})(ModuleId = exports.ModuleId || (exports.ModuleId = {}));
//# sourceMappingURL=ModuleId.js.map